import React from 'react';
import { FaEdit, FaEye } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import './ActionButtons.css';

const ActionButtons = ({ 
  onEdit, 
  onDelete, 
  onView, 
  showEdit = true, 
  showDelete = true, 
  showView = false 
}) => {
  return (
    <div className="action-buttons">
      {showEdit && (
        <button className="action-btn edit" onClick={onEdit}>
          <FaEdit />
        </button>
      )}
      {showDelete && (
        <button className="action-btn delete" onClick={onDelete}>
          <MdDelete size={16} />
        </button>
      )}
      {showView && (
        <button className="action-btn view" onClick={onView}>
          <FaEye />
        </button>
      )}
    </div>
  );
};

export default ActionButtons;